// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import JournalFormController from "./journal_form_controller"
application.register("journal-form", JournalFormController)

import InvoiceFormController from "./invoice_form_controller"
application.register("invoice-form", InvoiceFormController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import NavScrollController from "./nav_scroll_controller"
application.register("nav-scroll", NavScrollController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import CurrencyInputController from "./currency_input_controller"
application.register("currency-input", CurrencyInputController)


import StockCheckController from "./stock_check_controller"
application.register("stock-check", StockCheckController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import AdvanceScopeController from "./advance_scope_controller"
application.register("advance-scope", AdvanceScopeController)

import ReceiptVatController from "./receipt_vat_controller"
application.register("receipt-vat", ReceiptVatController)

import NumberingPreviewController from "./numbering_preview_controller"
application.register("numbering-preview", NumberingPreviewController)

import ReportBuilderController from "./report_builder_controller"
application.register("report-builder", ReportBuilderController)

import HeroVideoController from "./hero_video_controller"
application.register("hero-video", HeroVideoController)

import ChargeToController from "./charge_to_controller"
application.register("charge-to", ChargeToController)

import ReceiptAreaController from "./receipt_area_controller"
application.register("receipt-area", ReceiptAreaController)

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)
